import React from 'react';
import { DividerProps, DividerOrientation, DividerVariant } from '../../../types/DesignSystem/Divider';
import { withClassName } from '../cn';

/*
 * § 295 — the orientation picks the border SIDE. Both orientations used to share a
 * root `tw-border-t`, so the vertical rule — a `w-px h-full` box — drew a 1px top
 * border across its one-pixel width and rendered as a single dot. The showcase's
 * "Vertical Solid" exhibit showed it; the unit test asserted the `tw-h-full` class,
 * which is the jsdom trap: a class can be present and paint nothing.
 */
const orientationStyles: Record<DividerOrientation, string> = {
  horizontal: 'tw-w-full tw-h-px tw-border-t',
  vertical: 'tw-h-full tw-w-px tw-border-l',
};

const variantStyles: Record<DividerVariant, string> = {
  solid: 'tw-border-edge',
  dashed: 'tw-border-dashed tw-border-edge',
};

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(function Divider({
  orientation = 'horizontal',
  variant = 'solid',
  className = '',
  'data-testid': dataTestId,
  ...rest
}, ref) {
  return (
    <div
      {...rest}
      ref={ref}
      className={withClassName(`tw-border-0 ${orientationStyles[orientation]} ${variantStyles[variant]}`, className)}
      role="separator"
      aria-orientation={orientation}
      data-testid={dataTestId}
    />
  );
});

export default Divider;
